import { RequestService } from '../../../../../common/services/RequestService';
import { CREATE_REQUEST } from '../constants';

export const createRequestRequest = payload => {
  return RequestService.post(CREATE_REQUEST, JSON.stringify(payload));
};
